import { Archive, ArchiveRestore, Trash2, Download } from "lucide-react";
import { ORDER_STATUSES, STATUS_LABELS, STATUS_COLORS } from "./adminConstants";

export function OrdersView({ ctx }) {
  const {
    showArchived, toggleArchivedView, orderFilter, filterOrders, orders,
    cleanupPendingAction, exportCsv, exporting, changeOrderStatus,
    archiveOrderAction, deleteOrderAction,
  } = ctx;

  return (
    <div className="p-6 lg:p-12" data-testid="orders-view">
      <div className="flex flex-wrap gap-2 mb-4" data-testid="order-archive-toggle">
        <button
          onClick={() => toggleArchivedView(false)}
          className={`px-5 py-2.5 font-mono-accent text-[10px] uppercase tracking-widest border transition-colors ${!showArchived ? "bg-[#4A6E4A] text-[#E8E2D2] border-[#4A6E4A]" : "border-white/20 text-[#E8E2D2]/70 hover:border-[#4A6E4A]"}`}
          data-testid="view-active-orders"
        >
          Ordini attivi
        </button>
        <button
          onClick={() => toggleArchivedView(true)}
          className={`flex items-center gap-2 px-5 py-2.5 font-mono-accent text-[10px] uppercase tracking-widest border transition-colors ${showArchived ? "bg-[#5E6C5E] text-[#E8E2D2] border-[#5E6C5E]" : "border-white/20 text-[#E8E2D2]/70 hover:border-[#5E6C5E]"}`}
          data-testid="view-archived-orders"
        >
          <Archive className="w-3.5 h-3.5" /> Archivio
        </button>
      </div>
      <div className="flex flex-wrap items-center justify-between gap-4 mb-8">
        <div className="flex flex-wrap gap-2" data-testid="order-filters">
          <button
            onClick={() => filterOrders("")}
            className={`px-4 py-2 font-mono-accent text-[10px] uppercase tracking-widest border transition-colors ${orderFilter === "" ? "bg-[#D47738] text-[#0D110D] border-[#D47738]" : "border-white/20 text-[#E8E2D2]/70 hover:border-[#D47738]"}`}
            data-testid="filter-all"
          >
            Tutti
          </button>
          {ORDER_STATUSES.map((s) => (
            <button
              key={s}
              onClick={() => filterOrders(s)}
              className={`px-4 py-2 font-mono-accent text-[10px] uppercase tracking-widest border transition-colors ${orderFilter === s ? "bg-[#D47738] text-[#0D110D] border-[#D47738]" : "border-white/20 text-[#E8E2D2]/70 hover:border-[#D47738]"}`}
              data-testid={`filter-${s}`}
            >
              {STATUS_LABELS[s]}
            </button>
          ))}
        </div>
        <div className="flex items-center gap-2">
          {!showArchived && orders.some((o) => o.payment_status !== "paid") && (
            <button
              onClick={cleanupPendingAction}
              className="flex items-center gap-2 border border-[#9E3C3C]/40 px-5 py-2.5 font-mono-accent text-[10px] uppercase tracking-widest text-[#9E3C3C] hover:bg-[#9E3C3C]/10 transition-colors"
              data-testid="cleanup-pending-btn"
            >
              <Trash2 className="w-3.5 h-3.5" /> Elimina ordini di prova
            </button>
          )}
          <button
            onClick={exportCsv}
            disabled={exporting}
            className="flex items-center gap-2 border border-white/20 px-5 py-2.5 font-mono-accent text-[10px] uppercase tracking-widest text-[#E8E2D2] hover:border-[#D47738] hover:text-[#D47738] transition-colors disabled:opacity-40"
            data-testid="export-csv-btn"
          >
            <Download className="w-3.5 h-3.5" /> {exporting ? "Esporto..." : "Esporta CSV"}
          </button>
        </div>
      </div>
      {orders.length === 0 ? (
        <div className="border border-white/15 py-24 text-center font-mono-accent text-xs uppercase tracking-widest text-[#E8E2D2]/40">
          {showArchived
            ? "Nessun ordine in archivio"
            : `Nessun ordine ${orderFilter ? `con stato "${STATUS_LABELS[orderFilter]}"` : "ricevuto"}`}
        </div>
      ) : (
        <div className="space-y-4" data-testid="orders-list">
          {orders.map((o) => (
            <div key={o.session_id} className="border border-white/15 bg-[#141A14] p-6" data-testid={`order-${o.session_id}`}>
              <div className="flex flex-wrap items-start justify-between gap-4">
                <div>
                  <p className="font-serif-display text-2xl text-[#E8E2D2]">
                    {o.customer_name || o.customer_email || "Cliente"}
                  </p>
                  <p className="font-mono-accent text-[11px] text-[#E8E2D2]/50 mt-1">
                    {o.customer_email || "—"} · {o.created_at ? new Date(o.created_at).toLocaleString("it-IT") : ""}
                  </p>
                </div>
                <div className="text-right">
                  <p className="font-serif-display text-2xl text-[#D47738]">€ {Number(o.amount).toFixed(2)}</p>
                  {o.shipping_cost != null && (
                    <p className="font-mono-accent text-[10px] text-[#E8E2D2]/40 mt-1">
                      Merce € {Number(o.subtotal ?? o.amount).toFixed(2)} + Sped. {Number(o.shipping_cost) === 0 ? "Gratis" : `€ ${Number(o.shipping_cost).toFixed(2)}`}
                    </p>
                  )}
                  <span className={`font-mono-accent text-[10px] uppercase tracking-widest px-2 py-1 mt-1 inline-block ${o.payment_status === "paid" ? "bg-[#4A6E4A] text-[#E8E2D2]" : "bg-[#5E6C5E]/40 text-[#E8E2D2]/70"}`}>
                    {o.payment_status === "paid" ? "Pagato" : o.payment_status}
                  </span>
                  {o.payment_status === "paid" && (
                    <div className="mt-2 flex items-center justify-end gap-2" data-testid={`order-status-control-${o.session_id}`}>
                      <span className={`font-mono-accent text-[9px] uppercase tracking-widest px-2 py-1 border ${STATUS_COLORS[o.order_status] || "border-white/20 text-[#E8E2D2]/50"}`} data-testid={`order-status-badge-${o.session_id}`}>
                        {STATUS_LABELS[o.order_status] || "—"}
                      </span>
                      <select
                        value={o.order_status || "in_preparazione"}
                        onChange={(e) => changeOrderStatus(o.session_id, e.target.value)}
                        className="bg-[#0D110D] border border-white/20 text-[#E8E2D2] font-mono-accent text-[10px] uppercase tracking-widest px-2 py-1.5 focus:border-[#D47738] focus:outline-none cursor-pointer"
                        data-testid={`order-status-select-${o.session_id}`}
                      >
                        {ORDER_STATUSES.map((s) => (
                          <option key={s} value={s} className="bg-[#0D110D]">{STATUS_LABELS[s]}</option>
                        ))}
                      </select>
                    </div>
                  )}
                </div>
              </div>
              <div className="mt-4 flex flex-wrap gap-2">
                {(o.items || []).map((it, ii) => (
                  <span key={`${it.product_id || it.name}-${ii}`} className="border border-white/15 px-3 py-1 text-xs text-[#E8E2D2]/70">
                    {it.name} × {it.quantity}
                  </span>
                ))}
              </div>
              {o.shipping_address && (
                <p className="mt-4 text-sm text-[#E8E2D2]/70">
                  <span className="font-mono-accent text-[10px] uppercase tracking-widest text-[#D47738]">Spedizione: </span>
                  {o.shipping_address}
                </p>
              )}
              {o.invoice && o.invoice.wants_invoice && (
                <p className="mt-2 text-sm text-[#E8E2D2]/60">
                  <span className="font-mono-accent text-[10px] uppercase tracking-widest text-[#5E6C5E]">Fattura: </span>
                  {o.invoice.company_name} · P.IVA {o.invoice.vat_number} · SDI {o.invoice.sdi_code || "—"} · PEC {o.invoice.pec || "—"}
                </p>
              )}
              <div className="mt-5 pt-4 border-t border-white/10 flex flex-wrap items-center justify-between gap-3">
                <div className="font-mono-accent text-[10px] uppercase tracking-widest text-[#E8E2D2]/50">
                  {o.shipped_at ? (
                    <span data-testid={`order-shipped-at-${o.session_id}`}>
                      <span className="text-[#5E6C5E]">Data invio: </span>
                      {new Date(o.shipped_at).toLocaleDateString("it-IT")}
                    </span>
                  ) : (
                    <span className="text-[#E8E2D2]/30">Non ancora spedito</span>
                  )}
                  {o.archived && o.archived_at && (
                    <span className="ml-3 text-[#E8E2D2]/30">· Archiviato il {new Date(o.archived_at).toLocaleDateString("it-IT")}</span>
                  )}
                </div>
                <div className="flex items-center gap-2">
                  {o.archived ? (
                    <button
                      onClick={() => archiveOrderAction(o.session_id, false)}
                      className="flex items-center gap-2 border border-white/20 px-3 py-2 font-mono-accent text-[10px] uppercase tracking-widest text-[#E8E2D2] hover:border-[#4A6E4A] hover:text-[#4A6E4A] transition-colors"
                      data-testid={`order-restore-btn-${o.session_id}`}
                    >
                      <ArchiveRestore className="w-3.5 h-3.5" /> Ripristina
                    </button>
                  ) : (
                    <button
                      onClick={() => archiveOrderAction(o.session_id, true)}
                      className="flex items-center gap-2 border border-white/20 px-3 py-2 font-mono-accent text-[10px] uppercase tracking-widest text-[#E8E2D2] hover:border-[#5E6C5E] hover:text-[#5E6C5E] transition-colors"
                      data-testid={`order-archive-btn-${o.session_id}`}
                    >
                      <Archive className="w-3.5 h-3.5" /> Archivia
                    </button>
                  )}
                  <button
                    onClick={() => deleteOrderAction(o.session_id)}
                    className="flex items-center gap-2 border border-white/20 px-3 py-2 font-mono-accent text-[10px] uppercase tracking-widest text-[#9E3C3C] hover:border-[#9E3C3C] hover:bg-[#9E3C3C]/10 transition-colors"
                    data-testid={`order-delete-btn-${o.session_id}`}
                  >
                    <Trash2 className="w-3.5 h-3.5" /> Elimina
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
